import { useController } from 'react-hook-form';
import { TimeIn24HourClock, TimePicker, TimePickerProps } from 'ui/datePicker';
import { FieldProps } from './types';

type TimePickerFieldProps = FieldProps & Exclude<TimePickerProps, 'time' | 'onSelect'>;

export const TimePickerField = ({ name, defaultValue, ...props }: TimePickerFieldProps) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <TimePicker
      isError={!!error}
      {...props}
      time={value}
      onSelect={([time]) => onChange(time as TimeIn24HourClock)}
    />
  );
};
